// extracted by mini-css-extract-plugin
export default {"holder":"certificatesInCountries_holder__2A9P0","col":"certificatesInCountries_col__mqN-5"};